import { ActorLabel } from '~/components/common/actor-label';
import { ActorStringLabel } from '~/components/common/actor-string-label';

interface CostActorProps {
  /** The actor string the backend stored (an email, `system`, a Slack id …). */
  value: string | null | undefined;
  /** Display name the backend resolved for an email actor; absent on older estimates. */
  name?: string | null | undefined;
  showAvatar?: boolean;
  className?: string;
  /** `data-testid` passed to the actor label (default `cost-actor`). */
  testId?: string;
}

/**
 * Requester / decider label: the backend-resolved name (email on hover) when there is one,
 * otherwise the shared `ActorStringLabel` treatment of the raw actor string.
 */
export function CostActor({
  value,
  name,
  showAvatar = false,
  className,
  testId = 'cost-actor',
}: CostActorProps) {
  const email = value?.includes('@') ? value : null;
  if (name && email) {
    return (
      <ActorLabel
        actor={{
          id: null,
          displayName: name,
          kind: 'USER',
          email,
          avatarUrl: null,
          resolved: true,
        }}
        showAvatar={showAvatar}
        testId={testId}
        {...(className ? { className } : {})}
      />
    );
  }
  return (
    <ActorStringLabel
      value={value}
      showAvatar={showAvatar}
      testId={testId}
      {...(className ? { className } : {})}
    />
  );
}
